<script setup lang="ts">
  import { computed } from 'vue'

  import useI18n from '@/composables/useI18n'

  const { translateString } = useI18n()

  const props = defineProps({
    numberOfLessonsCompleted: {
      type: Number,
      required: true,
    },
    numberOfLessons: {
      type: Number,
      required: true,
    },
  })

  const progressPercentage = computed(() => {
    if (!props.numberOfLessons) return 0
    return Math.min(100, Math.round((props.numberOfLessonsCompleted / props.numberOfLessons) * 100))
  })

  const progressText = computed(() => {
    if (props.numberOfLessonsCompleted === 0) return `0/${props.numberOfLessons} ${translateString('courses.lessons')}`
    return `${props.numberOfLessonsCompleted}/${props.numberOfLessons} ${translateString('courses.lessons')}`
  })
</script>

<template lang="pug">
.lesson-progress
  .your-progress-wrapper
    h5.your-progress {{ $t('courses.yourProgress') }}
    h5.progress-text(v-if='numberOfLessonsCompleted') {{ progressText }}
  .progress-bar
    .progress-bar-fill(:style='{ width: `${progressPercentage}%` }')
      h6.progress-percentage {{ progressPercentage }}%
    h5.progress-text(v-if='numberOfLessonsCompleted === 0') {{ progressText }}
</template>

<style lang="postcss" scoped>
  .lesson-progress {
    @apply ketch-flex ketch-flex-col ketch-space-y-c10;

    .your-progress-wrapper {
      @apply ketch-flex ketch-items-center ketch-justify-between;
    }

    .progress-bar {
      @apply ketch-w-full ketch-h-[30px] ketch-rounded-[30px] ketch-bg-[#F2F2F5];
      @apply ketch-relative ketch-flex ketch-items-center ketch-overflow-hidden;

      .progress-bar-fill {
        @apply ketch-absolute ketch-left-0 ketch-top-0 ketch-h-[30px] ketch-min-w-[30px] ketch-rounded-[30px];
        @apply ketch-bg-secondary-color ketch-text-secondary-foreground-color;
        @apply ketch-flex ketch-items-center ketch-justify-center ketch-p-c10 ketch-transition-all ketch-duration-300;

        .progress-percentage {
          @apply ketch-font-bold;
        }
      }

      .progress-text {
        @apply ketch-absolute ketch-right-c10 ketch-text-primary-text-color ketch-text-opacity-60;
      }
    }
  }
</style>
